import biroBiborkaEszter from "../assets/images/speakers/biro-biborka-eszter.webp";
import biroBorokaJulia from "../assets/images/speakers/biro-boroka-julia.webp";
import bujtor from "../assets/images/speakers/bujtor.webp";
import dosa from "../assets/images/speakers/dosa.webp";
import frohlich from "../assets/images/speakers/frohlich.webp";
import fuleki from "../assets/images/speakers/fuleki.webp";
import gall from "../assets/images/speakers/gall.webp";
import hausmann from "../assets/images/speakers/hausmann.webp";
import jozsa from "../assets/images/speakers/jozsa.webp";
import martini from "../assets/images/speakers/martini.webp";
import munzlinger from "../assets/images/speakers/munzlinger.webp";
import vladimir from "../assets/images/speakers/vladimir.webp";

export const SpeakersImages = [
  biroBiborkaEszter,
  biroBorokaJulia,
  bujtor,
  dosa,
  frohlich,
  fuleki,
  gall,
  hausmann,
  jozsa,
  martini,
  munzlinger,
  vladimir,
];
